import React from "react";
import { ArrowRight } from "lucide-react";
import { MOVES } from "../mock";
import Reveal from "./Reveal";

const diffColor = { easy: "#13D99A", medium: "#F5A623", hard: "#FF4D4F" };

const RennMoves = () => {
  return (
    <section id="renn-moves" className="relative py-20 lg:py-28">
      <div className="max-w-6xl mx-auto px-5 lg:px-8">
        <Reveal className="max-w-2xl mb-14">
          <p className="text-[13px] font-semibold tracking-wide text-[#13D99A] uppercase mb-4">Renn Moves</p>
          <h2 className="font-display text-3xl lg:text-5xl font-bold text-[#F5F7FB] leading-[1.08]">
            {MOVES.headline}
          </h2>
          <p className="mt-5 text-lg text-[#8290A8] leading-relaxed">{MOVES.copy}</p>
        </Reveal>

        <div className="grid lg:grid-cols-3 gap-5">
          {MOVES.items.map((m, i) => (
            <Reveal key={m.n} delay={i * 100}>
              <div className="h-full rounded-2xl border border-[#29354A] bg-[#121A28] p-6 card-hover flex flex-col">
                <div className="flex items-center justify-between mb-5">
                  <span className="w-9 h-9 rounded-lg bg-[#10C98A]/15 text-[#13D99A] font-display font-bold flex items-center justify-center">
                    {m.n}
                  </span>
                  <span
                    className="text-xs font-semibold px-3 py-1 rounded-full"
                    style={{ color: diffColor[m.level], backgroundColor: `${diffColor[m.level]}1A` }}
                  >
                    {m.difficulty}
                  </span>
                </div>
                <h3 className="font-display text-lg font-bold text-[#F5F7FB] mb-2">{m.title}</h3>
                <p className="text-sm text-[#8290A8] leading-relaxed mb-5">{m.copy}</p>

                <div className="mt-auto space-y-4">
                  <div className="rounded-xl bg-[#0A1220] border border-[#29354A]/60 p-3">
                    <p className="text-[11px] uppercase tracking-wide text-[#8290A8] mb-1">Start here</p>
                    <p className="text-sm text-[#F5F7FB]">{m.action}</p>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-sm font-semibold text-[#13D99A]">{m.impact}</span>
                    <button className="btn-emerald inline-flex items-center gap-1.5 text-sm font-semibold text-[#050A12] bg-[#10C98A] px-4 py-2 rounded-full">
                      Start this Move <ArrowRight className="w-4 h-4" />
                    </button>
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal>
          <p className="mt-8 text-sm text-[#8290A8] max-w-3xl">{MOVES.note}</p>
        </Reveal>
      </div>
    </section>
  );
};

export default RennMoves;
